export var EPurOrderErrorCode;
(function (EPurOrderErrorCode) {
    EPurOrderErrorCode[EPurOrderErrorCode["EXISTS_PENDING_INVENTORY_ORDER"] = 3] = "EXISTS_PENDING_INVENTORY_ORDER";
    EPurOrderErrorCode[EPurOrderErrorCode["EXISTS_PENDING_STOCK_INIT_ORDER"] = 4] = "EXISTS_PENDING_STOCK_INIT_ORDER";
    EPurOrderErrorCode[EPurOrderErrorCode["EXISTS_PENDING_WAREHOUSE_ORDER"] = 5] = "EXISTS_PENDING_WAREHOUSE_ORDER";
    EPurOrderErrorCode[EPurOrderErrorCode["EXISTS_PENDING_SORTING_ORDER"] = 6] = "EXISTS_PENDING_SORTING_ORDER";
    EPurOrderErrorCode[EPurOrderErrorCode["EXISTS_PENDING_TRANSFER_ORDER"] = 7] = "EXISTS_PENDING_TRANSFER_ORDER";
    EPurOrderErrorCode[EPurOrderErrorCode["BUSINESS_GOODS_NOT_BIND"] = 8] = "BUSINESS_GOODS_NOT_BIND";
    EPurOrderErrorCode[EPurOrderErrorCode["GOODS_STOCK_IS_SHORT"] = 9] = "GOODS_STOCK_IS_SHORT";
})(EPurOrderErrorCode || (EPurOrderErrorCode = {}));
